/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './form-wrap-elements.scss';
import './modifier/form-wrap-elements-disclaimer.scss';
import './modifier/form-wrap-elements-full-width.scss';
import './modifier/form-wrap-elements-no-padding.scss';
import './modifier/form-wrap-elements-type.scss';
